import {
	EMPTY_PROJECTS_LIST,
	FETCH_PROJECT_LIST,
	FETCH_PROJECTS_NAME,
	FETCH_PROJECT_TYPES,
	IMPORT_THIRD_PARTY_PROJECT
} from '@/redux/actions/projects.actions'
import { DELETE_PROJECT, DUPLICATE_PROJECT, VERSION_PROJECT } from '@/redux/actions/project.actions'
import { LOGOUT } from '@/redux/actions/auth.actions'

const initialState = {
	loading: false,
	error: false,
	list: [],
	names: [],
	meta: {},
	type: [],
	versionProjectStatus: null
}

const loading = (state = initialState.loading, action) => {
	switch (action.type) {
		case FETCH_PROJECT_LIST.REQUEST:
			return action.payload.resetList || true
		case FETCH_PROJECTS_NAME.REQUEST:
			return true
		case FETCH_PROJECT_LIST.SUCCESS:
		case FETCH_PROJECT_LIST.FAILURE:
		case FETCH_PROJECTS_NAME.SUCCESS:
		case FETCH_PROJECTS_NAME.FAILURE:
			return false
		default:
			return state
	}
}

const error = (state = initialState.error, action) => {
	switch (action.type) {
		case FETCH_PROJECT_LIST.REQUEST:
		case FETCH_PROJECT_LIST.SUCCESS:
		case FETCH_PROJECTS_NAME.REQUEST:
		case FETCH_PROJECTS_NAME.SUCCESS:
		case IMPORT_THIRD_PARTY_PROJECT.REQUEST:
		case IMPORT_THIRD_PARTY_PROJECT.SUCCESS:
		case DUPLICATE_PROJECT.REQUEST:
		case DUPLICATE_PROJECT.SUCCESS:
		case VERSION_PROJECT.REQUEST: 
		case VERSION_PROJECT.SUCCESS:
			return false
		case FETCH_PROJECT_LIST.FAILURE:
		case FETCH_PROJECTS_NAME.FAILURE:
		case IMPORT_THIRD_PARTY_PROJECT.FAILURE:
		case DUPLICATE_PROJECT.FAILURE:
		case VERSION_PROJECT.FAILURE:
			return true
		default:
			return state
	}
}

const names = (state = initialState.names, action) => {
	switch (action.type) {
		case FETCH_PROJECTS_NAME.REQUEST:
			return []
		case FETCH_PROJECTS_NAME.SUCCESS:
			return action.payload
		case FETCH_PROJECTS_NAME.FAILURE:
			return []
		default:
			return state
	}
}

const list = (state = initialState.list, action) => {
	switch (action.type) {
		case FETCH_PROJECT_LIST.REQUEST:
			return action.payload.resetList
				? [...new Array(action.payload.itemsToLoad)]
				: [...state, ...new Array(action.payload.itemsToLoad)]
		case FETCH_PROJECT_LIST.SUCCESS: {
			const { docs: moreProjectsFetched } = action.payload
			const loadedProjects = [...state.slice(0, state.length - action.payload.itemsToLoad), ...moreProjectsFetched]
			return loadedProjects
		}
		case IMPORT_THIRD_PARTY_PROJECT.REQUEST:
		case DUPLICATE_PROJECT.REQUEST:
		case VERSION_PROJECT.REQUEST:
			return [...new Array(1), ...state]
		case IMPORT_THIRD_PARTY_PROJECT.SUCCESS: {
			return action.payload.importSuccess
				? [action.payload.data, ...state.slice(1, state.length)]
				: state.slice(1, state.length)
		}
		case DELETE_PROJECT.SUCCESS:
			return state.filter((item) => item?.id !== action.payload.projectId)
		case DELETE_PROJECT.FAILURE:
			return state
		case FETCH_PROJECT_LIST.FAILURE:
			return state.slice(0, state.length - action.payload.itemsToLoad)
		case IMPORT_THIRD_PARTY_PROJECT.FAILURE:
		case DUPLICATE_PROJECT.FAILURE:
		case VERSION_PROJECT.FAILURE:
			return state.slice(1, state.length)
		case EMPTY_PROJECTS_LIST:
		case LOGOUT.SUCCESS:
		case LOGOUT.FAILURE:
			return []

		default:
			return state
	}
}

const meta = (state = initialState.meta, action) => {
	switch (action.type) {
		case FETCH_PROJECT_LIST.SUCCESS: {
			const { docs: _docs, ...meta } = action.payload

			return meta
		}
		case FETCH_PROJECT_LIST.FAILURE:
		case FETCH_PROJECT_LIST.REQUEST:
			return {}
		default:
			return state
	}
}

const type = (state = initialState.type, action) => {
	switch (action.type) {
		case FETCH_PROJECT_TYPES.SUCCESS:
			return action.payload
		case FETCH_PROJECT_TYPES.FAILURE:
		case FETCH_PROJECT_TYPES.REQUEST:
			return []
		default:
			return state
	}
}

const versionProjectStatus = (state = initialState.versionProjectStatus, action) => {
	switch (action.type) {
		case VERSION_PROJECT.REQUEST:
			return 'loading'
		case VERSION_PROJECT.SUCCESS:
			return 'success'
		case VERSION_PROJECT.FAILURE:
			return 'failure'
		case 'RESET_VERSION_PROJECT_STATUS':
			return null
		default:
			return state
	}
}

export default {
	name: 'projects',
	reducers: {
		list,
		meta,
		names,
		loading,
		error,
		type,
		versionProjectStatus
	}
}
